import AuthService from '@/service/auth/AuthService'

export default [{
  name: 'signin',
  path: '/signin',
  beforeEnter(to, from, next) {
    if (window.DEBUG) {
      next()
      return
    }
    if (AuthService.isSignin() === true) {
      next('dashboard')
    } else {
      next()
    }
  },
  component: require('@/views/signin/Signin.vue').default
}]
